import SvgMarker from '#/assets/images/card/map-marker.svg'
import Button from '#/components/Button'
import useShowLocation from '../../hooks/useShowLocation'

type Props = {
  property: TopHap.Property
}

const ShowLocationButton: React.FC<Props> = ({ property }) => {
  const showLocation = useShowLocation(property, 'studio')

  return (
    <Button
      className='mx-auto my-3 h-10 rounded-full bg-primary px-4 text-sm text-white'
      onClick={showLocation}
    >
      <SvgMarker className='mr-1 h-[18px] w-[18px]' />
      Analyze in TopHap Studio
    </Button>
  )
}

export default ShowLocationButton
